import { UnitResultView } from './passing-policy-results.service';

export interface UnitStatusBadge {
  label: string;
  /** DaisyUI badge modifier class. */
  cssClass: string;
}

/** Map a unit status to a learner-facing label + DaisyUI badge class. */
export function unitStatusBadge(status: UnitResultView['status']): UnitStatusBadge {
  switch (status) {
    case 'passed':
      return { label: 'Passed', cssClass: 'badge-success' };
    case 'failed':
      return { label: 'Failed', cssClass: 'badge-error' };
    case 'pending':
      return { label: 'Pending', cssClass: 'badge-warning' };
    case 'in_progress':
      return { label: 'In progress', cssClass: 'badge-ghost' };
    default:
      return { label: '', cssClass: 'badge-ghost' };
  }
}

/**
 * Render the backend's canonical 1-decimal percentage verbatim - never
 * re-rounded, per the KAN-146 lesson.
 */
export function formatOneDecimal(pct: number): string {
  return Number.isInteger(pct) ? `${pct}.0` : `${pct}`;
}

/**
 * One-line summary, e.g. "Unit aggregate: 80.0% - Passed". The percentage is the
 * backend's canonical 1-decimal value rendered verbatim (never re-rounded, per
 * the KAN-146 lesson).
 */
export function unitAggregateLine(unit: UnitResultView): string {
  const badge = unitStatusBadge(unit.status);
  return `Unit aggregate: ${formatOneDecimal(unit.aggregatePercent)}%${badge.label ? ' - ' + badge.label : ''}`;
}
